








































































import InformationRow from '@/components/display/information-row.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FormInputRow from '@/components/form pickers/FormInputRow.vue';
import {
	ConsentCondition,
	ConsentWithId,
	Product,
	WaterExport,
	WaterExportStatusEnum,
} from '@/api';
import { ConsentCouncil, WaterExportModule } from '@/modules';
import WaterConsentConditionEditModal from '@/components/display/water-consents/conditions/water-consent-condition-edit-modal.vue';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import WaterConsentExportEditModal from '@/components/display/water-consents/exports/water-consent-export-edit-modal.vue';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';
import WaterConsentExportChangelogModal from '@/components/display/water-consents/exports/water-consent-export-changelog-modal.vue';

@Component({
	components: {
		WaterConsentExportChangelogModal,
		WaterConsentExportEditModal,
		ConfirmModal,
		WaterConsentConditionEditModal,
		FormInputRow,
		InformationRow,
	},
})
export default class WaterConsentConditions extends Vue {
	private readonly toast: Toast = new Toast();
	private readonly waterExportModule: WaterExportModule = new WaterExportModule();

	@Prop({ required: true })
	public product!: Product;

	@Prop({ required: true })
	public consent!: ConsentWithId &
		ConsentCouncil & { active?: boolean; consentconditions?: ConsentCondition[] };

	protected waterExports: WaterExport[] = [];
	protected selectedWaterExport: WaterExport = {};

	protected deleteWaterExport?: WaterExport | null;
	protected deletingWaterExport: boolean = false;

	protected readonly waterExportFields: { key: string; label: string }[] = [
		{ key: 'status', label: 'Status' },
		{ key: 'consentIdentifier', label: 'Consent Identifier' },
		{ key: 'actions', label: '' },
	];

	public async mounted() {
		await this.onConsentChanged();
	}

	@Watch('consent', { deep: true })
	@Watch('product')
	public async onConsentChanged() {
		if (!this.product?.id) return;
		this.waterExports = await this.waterExportModule.getWaterExportsForProduct(this.product.id);
	}

	public getStatusVariant(status: string): string {
		switch (status) {
			case WaterExportStatusEnum.Enabled:
				return 'success';
			case WaterExportStatusEnum.InternalOnly:
				return 'warning';
		}
		return 'dark';
	}

	public openChangelogModal(waterExport?: WaterExport): void {
		if (!waterExport) return;
		this.selectedWaterExport = waterExport;
		this.$bvModal.show('waterExportChangelogModal');
	}

	public openAddEditModal(waterExport?: WaterExport): void {
		this.selectedWaterExport = waterExport ?? {};
		this.$bvModal.show('addEditWaterExportModal');
	}

	protected async onSavedWaterExport(waterExport: WaterExport): Promise<void> {
		const existingIndex = this.waterExports.findIndex(e => e.id == waterExport.id);
		const existing = this.waterExports[existingIndex];
		if (existingIndex >= 0)
			this.waterExports.splice(existingIndex, 1, {
				...existing,
				...waterExport,
			});
		else await this.onConsentChanged();
	}

	protected openDeleteWaterExport(waterExport?: WaterExport): void {
		this.deleteWaterExport = waterExport;
		this.$bvModal.show('deleteWaterExportModal');
	}

	protected async onDeleteWaterExport(waterExport?: WaterExport | null): Promise<void> {
		if (waterExport?.id) {
			this.deletingWaterExport = true;
			try {
				await this.waterExportModule.delete(waterExport.id);
				const index = this.waterExports.findIndex(e => e.id === waterExport.id);
				if (index >= 0) this.waterExports.splice(index, 1);
				this.$bvModal.hide('deleteWaterExportModal');
			} catch (e) {
				const { errorMessage } = ApiUtils.handleApiError(
					e,
					'There was an issue deleting the water export',
				);
				this.toast.makeToast(errorMessage, 'Error', 'danger');
			}
			this.deletingWaterExport = false;
		}
	}
}
